export const getContactKeyFirstAndLastName = (
  contactKeyFirstName,
  contactKeyLastName,
  contactKeyInactive
) => {
  return (
    contactKeyFirstName + ' ' + contactKeyLastName + ' ' + contactKeyInactive
  );
};
